import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';

interface LanguageSwitcherProps {
  isDarkMode: boolean;
  collapsed?: boolean;
}

export default function LanguageSwitcher({ isDarkMode, collapsed = false }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const isKorean = i18n.language === 'ko';

  const handleToggle = () => {
    const nextLang = isKorean ? 'en' : 'ko';
    i18n.changeLanguage(nextLang);
    localStorage.setItem('language', nextLang);
  };

  if (collapsed) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={handleToggle}
          size="small"
          sx={{
            minWidth: 0,
            px: 0.5,
            fontSize: 11,
            fontWeight: 700,
            color: isDarkMode ? '#ccc' : '#666',
            '&:hover': { color: isDarkMode ? '#fff' : '#000' },
          }}
        >
          {isKorean ? 'EN' : 'KO'}
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Button
        onClick={() => { i18n.changeLanguage('ko'); localStorage.setItem('language', 'ko'); }}
        size="small"
        sx={{
          minWidth: 0,
          px: 1,
          fontSize: 12,
          fontWeight: i18n.language === 'ko' ? 700 : 400,
          color: i18n.language === 'ko'
            ? (isDarkMode ? '#fff' : '#000')
            : (isDarkMode ? '#9ca3af' : '#9ca3af'),
          textDecoration: i18n.language === 'ko' ? 'underline' : 'none',
          textTransform: 'none',
        }}
      >
        KO
      </Button>
      <Box sx={{ color: isDarkMode ? '#4b5563' : '#d1d5db', display: 'flex', alignItems: 'center', fontSize: 12 }}>|</Box>
      <Button
        onClick={() => { i18n.changeLanguage('en'); localStorage.setItem('language', 'en'); }}
        size="small"
        sx={{
          minWidth: 0,
          px: 1,
          fontSize: 12,
          fontWeight: i18n.language === 'en' ? 700 : 400,
          color: i18n.language === 'en'
            ? (isDarkMode ? '#fff' : '#000')
            : (isDarkMode ? '#9ca3af' : '#9ca3af'),
          textDecoration: i18n.language === 'en' ? 'underline' : 'none',
          textTransform: 'none',
        }}
      >
        EN
      </Button>
    </Box>
  );
}
